import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons'
import { Modal } from 'hljd'
import style from './style.module.less'
import Store from './store'

const iconStyle = {
  fontSize: '20px',
  cursor: 'pointer',
  color: '#fff'
}

const filePath = '//qnm.hunliji.com/o_1d6i2pfg11fsn1tqkprv1t251ol99.png'

@observer
export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
  }

  render() {
    const { list = [], children, onDelete, viewer } = this.props
    const {
      showPanel,
      changePanelState,
      onPreview,
      showModal,
      modalLink,
      onCancel
    } = this.store

    return (
      <>
        {list.map((el, i) => {
          const { coverPath } = el
          // todo 文件类型
          const isImage = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG|JPEG)$/.test(
            coverPath
          )
          return (
            <div
              key={i}
              className={style.container}
              onMouseEnter={() => changePanelState(true, i)}
              onMouseLeave={() => changePanelState(false, i)}
            >
              <img
                key={i}
                className={style.img}
                src={isImage ? el.coverPath : filePath}
              />

              <div
                className={
                  !viewer &&
                  showPanel.index == i &&
                  showPanel.status &&
                  !isImage
                    ? style.fileMask
                    : style.fileMaskHidden
                }
              />

              <div
                className={
                  showPanel.index == i && showPanel.status
                    ? style.panelMask
                    : style.panelMaskHidden
                }
              />

              <div
                className={
                  showPanel.index == i && showPanel.status
                    ? style.panelShow
                    : style.panelHidden
                }
              >
                {isImage && (
                  <EyeOutlined
                    style={iconStyle}
                    onClick={() => onPreview(coverPath)}
                  />
                )}

                {!viewer && (
                  <DeleteOutlined
                    style={iconStyle}
                    onClick={() => onDelete(i)}
                  />
                )}
              </div>
            </div>
          )
        })}
        {children}
        <Modal
          closable={true}
          maskClosable={true}
          width={800}
          footer={null}
          visible={showModal}
          onCancel={onCancel}
          destroyOnClose={true}
        >
          <img className={style.modalLink} src={modalLink} />
        </Modal>
      </>
    )
  }
}
